import * as React from 'react';
import { Field, Form } from 'formik';
import * as Yup from 'yup';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';


const UserSchema = Yup.object().shape({
  password: Yup.string(),
  newPassword: Yup.string(),
  newPasswordRe: Yup.string().test('match', 'Passwords do not match.', function (newPasswordRe: string) {
    return newPasswordRe == this.options.parent.newPassword;
  }),
});


const UserProfileForm = (props) => {
  const { user, error, success, onSubmit } = props;

  return (
    <div className="sett__view">
      <div className="sett__title" />

      <div className="sett__user">
        {/*
        <div className="sett__user__img">
          <img src="/assets/img/placeholder/logo-alt.svg" alt=""/>
        </div>
        */}

        <div className="sett__user__details">
          <span className="sett__user__name">{user.firstName} {user.lastName}</span>
          <span className="sett__user__mail">{user.email}</span>
        </div>

      </div>
      <FormikForm
        initialValues={user}
        validateOnInit
        onSubmit={(data) => onSubmit(UserSchema.cast(data))}
        validationSchema={UserSchema}
        render={(props) => {
          return (
            <Form className="form__cont">
              <div className="form--auto">
                <Field
                  name="password"
                  label="Current Password"
                  className="input input--md input--lite"
                  type="password"
                  component={Input}
                />
              </div>
              <div className="form--auto">
                <Field
                  name="newPassword"
                  label="New Password"
                  className="input input--md input--lite"
                  type="password"
                  component={Input}
                />
                <Field
                  name="newPasswordRe"
                  label="Re-Confirm New Password"
                  className="input input--md input--lite"
                  type="password"
                  component={Input}
                />
              </div>
              {error && <div className="form__note">{error}</div>}
              {success && <div className="form__note">{success}</div>}
              <button
                type="submit"
                className="btn btn--lite btn--xlg fw">Save Changes</button>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default UserProfileForm;
